import { useState } from 'react'
import styles from './NoteForm.module.css'

const NoteForm = ({ addNote }) => {
  const [newNote, setNewNote] = useState('')

  const handleInputChange = e => {
    setNewNote(e.target.value)
  }

  const handleSave = e => {
    e.preventDefault()
    const noteObject = {
      content: newNote,
      important: true,
    }
    addNote(noteObject)
    setNewNote('')
  }

  return (
    <div className={styles.note}>
      <form
        onSubmit={handleSave}
        className={[styles.form].join(' ')}
      >
        <input
          id="newNoteContentInput"
          value={newNote}
          onChange={handleInputChange}
          placeholder="what's on your mind?"
        />
        <button
          id="newNoteSubmitButton"
          className="btn-accent-dark"
          type="submit"
        >
          save
        </button>
      </form>
    </div>
  )
}

export default NoteForm
